import React, { FC, useContext, useEffect, useState } from 'react';
import { CustomModal, MaxTagComponent } from '../../PricingSimulator/Modals/CreateEditProjectContainer';
import { colorConstants } from 'config/colorConstants';
import { Radio } from 'antd';
import { CustomSlider, sliderFontSize, sliderWidth } from 'components/template/BumpReport/MainSection';

type Props = {
    open: boolean;
    sliderValue: number;
    onCancel: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onSubmit: (weekSliderValue: number, viewType: 'weekly' | 'monthly') => void;
};

const sliderMarks: any = {
    12: { label: '12W', value: 12, style: { fontSize: sliderFontSize } },
    32: { label: '26W', value: 26, style: { fontSize: sliderFontSize } }, //manipulating 32 with 26 because 26 needs to be shown at the center
    52: { label: '52W', value: 52, style: { fontSize: sliderFontSize } },
};

const CalenderViewPopup: FC<Props> = ({ open, onCancel, onSubmit, sliderValue }) => {
    const [viewType, setViewType] = useState<'weekly' | 'monthly'>('weekly');
    const [weekSliderValue, setWeekSliderValue] = useState<number>(sliderValue);
    const handleSliderChange = (value: number) => {
        // if (value === 32) return setSliderValue(26);
        const sliderValue = sliderMarks?.[value]?.value;
        setWeekSliderValue(sliderValue);
    };

    function resetSlider() {
        return sliderMarks[Object.keys(sliderMarks)[0]]?.value;
    }

    //reset on popup close
    useEffect(() => {
        if (!open) {
            setWeekSliderValue(sliderValue);
            setViewType('weekly');
        }
    }, [open]);

    return (
        <div>
            <CustomModal
                bodyStyle={{ paddingTop: 0 }}
                style={{ borderRadius: 8 }}
                cancelButtonProps={{ style: { borderRadius: 6 } }}
                okButtonProps={{ style: { borderRadius: 6 } }}
                okText={'Apply'}
                maskClosable={false}
                destroyOnClose
                centered
                onOk={() => {
                    onSubmit(weekSliderValue, viewType);
                }}
                open={open}
                width={420}
                onCancel={(e) => {
                    onCancel(e);
                }}
                title={'Calender View'}
            >
                <div className="rounded px-6 py-4 border border-backgroundGreyAlt6">
                    <div className="font-xs mb-3  text-fontGreyAlt">Choose view option</div>
                    <Radio.Group
                        onChange={(e) => {
                            setViewType(e.target.value);
                        }}
                        value={viewType}
                    >
                        <div>
                            <Radio
                                disabled={false}
                                style={{ color: colorConstants.blackAlt1, width: 200, marginBottom: 4 }}
                                value={'weekly'}
                            >
                                <span className="font-xs">Weekly </span>
                            </Radio>
                            <CustomSlider
                                style={{ width: 150 }}
                                max={52}
                                min={12}
                                step={null}
                                marks={sliderMarks}
                                value={weekSliderValue}
                                tooltip={{ open: false }}
                                onChange={handleSliderChange}
                            />
                        </div>

                        {/* <Radio
                            disabled={false}
                            style={{ marginTop: 10, color: colorConstants.blackAlt1 }}
                            value={'monthly'}
                        >
                            <span className="font-xs">Monthly</span>
                        </Radio> */}
                    </Radio.Group>
                </div>
            </CustomModal>
        </div>
    );
};

export default CalenderViewPopup;
